export default __webpack_public_path__ + "static/media/MEGA.33277811.png";